<template>
	<div class="rounded-lg bg-white border-2 border-gray-200 px-3 py-2 mb-1 flex justify-between items-center">
		<div>
			<p class="text-xs font-medium text-gray-600">{{name}}:</p>
			<p class="text-xl lg:text-lg xl:text-2xl font-semibold text-gray-800">{{currency}} {{number}}</p>
		</div>
		<div class="hidden sm:flex  bg-[#f1edf7] rounded-full w-10 h-10 flex items-center justify-center">
			<LucideIcon :name="icon" :size="22" :stroke-width="1.8" color="#302E81" class="self-center" />
		</div>
	</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";

export default {
	name:"stat-box",
	components:{
        LucideIcon
	},
	props:{
		name:{
			type:String
		},
		number:{
			type:String
		},
		currency:{
			type:String
		},
		icon:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>